import { render, staticRenderFns } from "./SalesFlyerLightboxViewMobile.vue?vue&type=template&id=27e040b6"
import script from "./SalesFlyerLightboxViewMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesFlyerLightboxViewMobile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SalesFlyerLightboxViewMobile.vue?vue&type=style&index=0&id=27e040b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports